import {authAxios} from "../api/axiosClient";
import {listTeamURL, listBoPhanURL, listChiTietBoPhanURL, changeTeamURL} from "../constants";

const ListTeamApi = (params={})=>{
        const url = listTeamURL;
        return authAxios().get(url);
}

export default ListTeamApi;


export const ListBoPhanApi = (params={})=>{
        const url = listBoPhanURL;
        return authAxios().get(url,{params});
};

export const ListChiTietBoPhanApi = (params={})=>{
        const url = listChiTietBoPhanURL;
        return authAxios().get(url,{params});
};

export const PostBoPhanApi = (params={})=>{
        const url = listBoPhanURL;
        return authAxios().post(url, params);
};

export const PostTeamApi = (params={})=>{
        const url = listTeamURL;
        return authAxios().post(url, params);
};

export const PutTeamApi = (params={})=>{
        const url = listTeamURL;
        return authAxios().put(url, params);
}

export const PutChangeTeamApi = (params={})=>{
        const url = changeTeamURL;
        return authAxios().put(url, params);
}